import { TFunction } from 'react-i18next';
import { MeasureUnitCode } from './types';

export const getPackageQuantityLabel = (unitCode: MeasureUnitCode | undefined, t: TFunction): string => {
  switch (unitCode) {
    case MeasureUnitCode.PIECE:
    case MeasureUnitCode.SET:
    case MeasureUnitCode.PAIR:
    case MeasureUnitCode.PACK:
    case MeasureUnitCode.PACKAGE:
    case MeasureUnitCode.REEL:
      return t('package_quantity_label_count');
    case MeasureUnitCode.KILOGRAM:
    case MeasureUnitCode.GRAM:
    case MeasureUnitCode.TON:
      return t('package_quantity_label_weight');
    case MeasureUnitCode.LITER:
    case MeasureUnitCode.CUBIC_METER:
      return t('package_quantity_label_volume');
    case MeasureUnitCode.METER:
    case MeasureUnitCode.LINEAR_METER:
    case MeasureUnitCode.BAY:
      return t('package_quantity_label_length');
    case MeasureUnitCode.SQUARE_METER:
      return t('package_quantity_label_area');
    default:
      return t('package_quantity_label_default');
  }
};

export const isServiceUnit = (unitCode: MeasureUnitCode | undefined): boolean => {
  return unitCode === MeasureUnitCode.SERVICE;
};

export const isIntegerUnit = (unitCode: MeasureUnitCode | undefined): boolean => {
  switch (unitCode) {
    case MeasureUnitCode.PIECE:
    case MeasureUnitCode.PACKAGE:
    case MeasureUnitCode.SET:
    case MeasureUnitCode.PAIR:
    case MeasureUnitCode.PACK:
    case MeasureUnitCode.REEL:
      return true;
    default:
      return false;
  }
};
